/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

function throttle(f: (...args: any[]) => void, ms = 10): (...args: any[]) => void {
    let isCooldown = false;

    return function(...args: any[]): void {
        if (isCooldown) return;

        f.apply(f, args);

        isCooldown = true;

        setTimeout(() => isCooldown = false, ms);
    };

}

function debounce(func: Function, wait: number, immediate?: boolean) {
    let timeout: number | null;

    return function executedFunction(...args: any[]) {
        const later = function() {
            timeout = null;
            // eslint-disable-next-line prefer-spread
            if (!immediate) func.apply(func, args);
        };

        const callNow = immediate && !timeout;

        window.clearTimeout(timeout as number);

        timeout = window.setTimeout(later, wait);

        // eslint-disable-next-line prefer-spread
        if (callNow) func.apply(func, args);
    };
}

export {
    throttle,
    debounce,
};
